import { render, staticRenderFns } from "./AperturaDevolucion.vue?vue&type=template&id=2d5c3986&scoped=true&"
import script from "./AperturaDevolucion.vue?vue&type=script&lang=js&"
export * from "./AperturaDevolucion.vue?vue&type=script&lang=js&"
import style0 from "./AperturaDevolucion.vue?vue&type=style&index=0&id=2d5c3986&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5c3986",
  null
  
)

export default component.exports